import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=48354b0e&"
import script from "./Notifications.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./Notifications.vue?vue&type=script&lang=ts&scoped=true&"
import style0 from "./Notifications.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports